module.exports = __webpack_public_path__ + "static/media/JobfunktionAndre.2b10e1d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Courses/JobfunktionAndre.jpg
// module id = 1528
// module chunks = 0